import type { Block } from 'src/__generated__/graphqlTypes';

import type { ParsedBlocks, ParsedModalBlocks } from '../config/declarations';
import { BlockType, ModalBlockSlug } from '../config/constants';

export const parseModalBlocks = (blocks: Array<Block>): ParsedModalBlocks => blocks
  .reduce((parsed, block) => {
    if (!block.slug) return parsed;

    switch (block.slug) {
      case ModalBlockSlug.HEADER:
        return { ...parsed, headerBlock: block };
      case ModalBlockSlug.BUTTON:
        return { ...parsed, buttonBlock: block };
      case ModalBlockSlug.OFFER_DETAILS:
        return { ...parsed, offerDetailsBlock: block };
      case ModalBlockSlug.LEGAL_TERMS:
        return { ...parsed, legalTermsBlock: block };
      default:
        return parsed;
    }
  }, {} as ParsedModalBlocks);

export const parseBlocks = (
  blocks: Array<Block>,
): Partial<ParsedBlocks> => blocks
  .reduce((acc, item) => {
    switch (item.slug) {
      case BlockType.CLOSE_HANDLER:
        return { ...acc, closeHandler: item };
      case BlockType.ADDITIONAL_LOGIC:
        return { ...acc, additionalLogic: item };
      case BlockType.OPEN_HANDLER:
        return { ...acc, openHandler: item };
      case BlockType.DYNAMIC:
        return { ...acc, dynamicBlock: item };
      default:
        return { ...acc, defaultBlock: item };
    }
  }, {});
